import { ROUTER_PATHS } from '~/constants/index';
import { Users } from '~/pages/Portal/Admin/Users';
import { UserForm } from '~/pages/Portal/Admin/Users/UserForm';
import { Groups } from '~/pages/Portal/Admin/Groups';
import { GroupForm } from '~/pages/Portal/Admin/Groups/GroupForm';
import { Companies } from '~/pages/Portal/Admin/Companies';
import { CompanyDetails } from '~/pages/Portal/Admin/Companies/CompanyDetail';
import { CompanyForm } from '~/pages/Portal/Admin/Companies/CompanyForm';
import { AccessReports } from '~/pages/Portal/Admin/AccessReports';
import { AccessReportsDetails } from '~/pages/Portal/Admin/AccessReports/AccessReportsDetails';
import { EquipmentTypes } from '~/pages/Portal/Admin/Equipments/EquipmentTypes';
import { EquipmentModels } from '~/pages/Portal/Admin/Equipments/EquipmentModels';
import { Equipments } from '~/pages/Portal/Admin/Equipments';
import { EquipmentForm } from '~/pages/Portal/Admin/Equipments/EquipmentForm';
import { ResetCache } from '~/pages/Portal/Admin/ResetCache';
import { HistJSON } from '~/pages/Portal/Admin/JSON';
import { Discount } from '~/pages/Portal/Settings/Discounts/Discount';
import { NonPayment } from '~/pages/Portal/Settings/NonPayment/NonPayment';
import { Announcements } from '~/pages/Portal/Admin/Announcements';
import { NewAnnouncements } from '~/pages/Portal/Admin/Announcements/NewAnnouncements';
import { AnnouncementDetail } from '~/pages/Portal/Admin/Announcements/AnnouncementDetail';
import { PrivacyPolicy } from '~/pages/Portal/Admin/PrivacyPolicy';
import { NewPrivacyPolicy } from '~/pages/Portal/Admin/PrivacyPolicy/NewPrivacyPolicy';
import { PrivacyPolicyDetail } from '~/pages/Portal/Admin/PrivacyPolicy/PrivacyPolicyDetail';
import { RouteInterface } from '~/types/routesInterface';
import { RolesEnum } from '~/utils/roles';
import { Home } from '~/pages/Portal/Home';
import { Contracts } from '~/pages/Portal/Contract';
import { ContractDetail } from '~/pages/Portal/Contract/ContractDetail';
import { Invoices } from '~/pages/Portal/Invoices';
import { InvoiceDetail } from '~/pages/Portal/Invoices/InvoiceDetail';
import { Sinisters } from '~/pages/Portal/Sinisters';
import { SinisterDetail } from '~/pages/Portal/Sinisters/SinisterDetail';
import { Occurrences } from '~/pages/Portal/Occurrences';
import { NewOccurrence } from '~/pages/Portal/Occurrences/NewOccurrence';
import { OccurrenceDetail } from '~/pages/Portal/Occurrences/OccurrenceDetail';
import { BusinessInformation } from '~/pages/Portal/BusinessInformation';
import { Profile } from '~/pages/Portal/Settings/Profile';
import { Emails } from '~/pages/Portal/Settings/Emails';
import { ContactUs } from '~/pages/Portal/ContactUs';
import { TechnicalSupport } from '~/pages/Portal/TechnicalSupport';
import { Documents } from '~/pages/Portal/Documents';
import { ContractExtension } from '~/pages/Portal/Contract/ContractExtension';
import { userCanSeeBusinessInfo } from '~/utils/validateUserPermissions';
import { ContractMeasurement } from '~/pages/Portal/ContractMeasurement';
import { Insurance } from '~/pages/Portal/Insurance';
import { ZeroCarbonProjects } from '~/pages/Portal/Admin/ZeroCarbon/ZeroCarbonProjects';
import { CreateZeroCarbonProject } from '~/pages/Portal/Admin/ZeroCarbon/CreateZeroCarbonProject';
import { ZeroCarbonLetters } from '~/pages/Portal/Admin/ZeroCarbon/ZeroCarbonLetters';
import { ZeroCarbonLettersNew } from '~/pages/Portal/Admin/ZeroCarbon/ZeroCarbonLetters/ZeroCarbonLettersNew';
import { ViewLetter } from '~/pages/Portal/Admin/Groups/ViewLetter';
import { Report } from '~/pages/Portal/PowerBIReport/Report';
import { Dashboards } from '~/pages/Portal/Admin/Dashboards';
import { StrategicMap } from '~/pages/Portal/StrategicMap';
import { RequestContractTermination } from '~/pages/Portal/TerminationRequests/RequestContractTermination';
import { RequestContractTerminationList } from '~/pages/Portal/TerminationRequests/RequestContractTerminationList';
import { AutomaticAnalysis } from '~/pages/Portal/Settings/AutomaticAnalysis/AutomaticAnalysis';

export const PORTAL_ROUTES_DEFINITION: RouteInterface[] = [
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.USERS,
    component: Users,
    roles: [RolesEnum.ADMINISTRADOR, RolesEnum.CLIENTE_MASTER],
    // accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.USERS_FORM,
    component: UserForm,
    roles: [RolesEnum.ADMINISTRADOR, RolesEnum.CLIENTE_MASTER],
    // accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.GROUPS,
    component: Groups,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.GROUPS_FORM,
    component: GroupForm,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.COMPANIES,
    component: Companies,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.COMPANY_DETAIL,
    component: CompanyDetails,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.COMPANY_FORM,
    component: CompanyForm,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ACCESS_REPORTS,
    component: AccessReports,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ACCESS_REPORTS_DETAIL,
    component: AccessReportsDetails,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.EQUIPMENT_TYPES,
    component: EquipmentTypes,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.EQUIPMENT_MODELS,
    component: EquipmentModels,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.EQUIPMENTS,
    component: Equipments,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.EQUIPMENTS_FORM,
    component: EquipmentForm,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.EQUIPMENTS_FORM_EDIT,
    component: EquipmentForm,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.RESET_CACHE,
    component: ResetCache,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.JSON,
    component: HistJSON,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.DISCOUNT,
    component: Discount,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.NON_PAYMENT,
    component: NonPayment,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ANNOUNCEMENTS,
    component: Announcements,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.NEW_ANNOUNCEMENTS,
    component: NewAnnouncements,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.EDIT_ANNOUNCEMENTS,
    component: NewAnnouncements,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ANNOUNCEMENTS_DETAIL,
    component: AnnouncementDetail,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.PRIVACYPOLICY,
    component: PrivacyPolicy,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.NEW_PRIVACYPOLICY,
    component: NewPrivacyPolicy,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.EDIT_PRIVACYPOLICY,
    component: NewPrivacyPolicy,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.PRIVACYPOLICY_DETAIL,
    component: PrivacyPolicyDetail,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ZERO_CARBON_PROJECTS,
    component: ZeroCarbonProjects,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ZERO_CARBON_LETTERS,
    component: ZeroCarbonLetters,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ZERO_CARBON_LETTERS_NEW,
    component: ZeroCarbonLettersNew,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.VIEW_LETTER,
    component: ViewLetter,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ZERO_CARBON_LETTERS_EDIT,
    component: ZeroCarbonLettersNew,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.ZERO_CARBON_CREATE_PROJECT,
    component: CreateZeroCarbonProject,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.EMAILS,
    component: Emails,
    roles: [RolesEnum.ADMINISTRADOR],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.HOME,
    component: Home,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.CONTRACTS,
    component: Contracts,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.CONCTRACT_DETAIL,
    component: ContractDetail,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.INVOICES,
    component: Invoices,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.INVOICES_DETAIL,
    component: InvoiceDetail,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.SINISTERS,
    component: Sinisters,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.TECNICO,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.SINISTERS_DETAIL,
    component: SinisterDetail,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.TECNICO,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.OCCURRENCES,
    component: Occurrences,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.NEW_OCCURRENCE,
    component: NewOccurrence,
    roles: [RolesEnum.CLIENTE, RolesEnum.CLIENTE_MASTER],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.OCCURRENCE_DETAIL,
    component: OccurrenceDetail,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.BUSINESS_INFORMATION,
    component: BusinessInformation,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
    ],
    checkAccess: (params, roles) => {
      const { user, isStorageValid } = params;

      if (!isStorageValid) {
        return false;
      }

      return userCanSeeBusinessInfo(user, roles);
    },
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.CONTRACT_MEASUREMENT,
    component: ContractMeasurement,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.TECNICO,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.PROFILE,
    component: Profile,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.TECNICO,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.CONTACT,
    component: ContactUs,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.TECNICO,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.TECHNICAL_SUPPORT,
    component: TechnicalSupport,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ANNOUNCEMENTS,
    component: Announcements,
    roles: [
      RolesEnum.TECNICO,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.DOCUMENTS,
    component: Documents,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.SUPORTE,
    ],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.INSURANCE,
    component: Insurance,
    roles: [RolesEnum.ADMINISTRADOR, RolesEnum.OPERACIONAL, RolesEnum.SUPORTE],
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.CONTRACT_EXTENSION,
    component: ContractExtension,
    roles: [RolesEnum.CLIENTE, RolesEnum.CLIENTE_MASTER],
    checkAccess: (params, roles) => {
      const { user, isStorageValid } = params;

      if (!isStorageValid) {
        return false;
      }

      const keys = Object.keys(RolesEnum) as (keyof typeof RolesEnum)[];
      const foundKey = keys.find(
        key => RolesEnum[key] === user.funcao.toLocaleLowerCase(),
      );
      if (!foundKey) {
        // nao encontrou a funcao do usuario
        console.log('funcao nao encontrada', user.funcao.toLocaleLowerCase());
        return false;
      }

      return !!(roles?.includes(RolesEnum[foundKey]) && user?.responsavel);
    },
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.POWERBI_REPORT,
    component: Report,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.TECNICO,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.PARCEIRO_COMERCIAL,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
    ],
    featureFlagName: 'dashboardsPowerBiEmbeddedEnabled',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.DASHBOARDS,
    component: Dashboards,
    roles: [RolesEnum.ADMINISTRADOR],
    featureFlagName: 'crudDashboardsPowerBiEmbeddedEnabled',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.STRATEGIC_MAP,
    component: StrategicMap,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
      RolesEnum.TECNICO,
    ],
    featureFlagName: 'mapaEstrategicoEnabled',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.REQUEST_CONTRACT_TERMINATION,
    component: RequestContractTermination,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
    ],
    featureFlagName: 'solicitarRescisaoContratosEnabled',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.REQUEST_CONTRACT_TERMINATION_LIST,
    component: RequestContractTerminationList,
    roles: [
      RolesEnum.ADMINISTRADOR,
      RolesEnum.GERENTE_CONTAS,
      RolesEnum.OPERACIONAL,
      RolesEnum.SUPORTE,
      RolesEnum.TECNICO,
      RolesEnum.CLIENTE,
      RolesEnum.CLIENTE_MASTER,
    ],
    featureFlagName: 'solicitarRescisaoContratosEnabled',
  },
  {
    exact: true,
    path: ROUTER_PATHS.PORTAL.ADMIN.AUTOMATIC_ANALYSIS,
    component: AutomaticAnalysis,
    roles: [RolesEnum.ADMINISTRADOR],
    accessTypes: 'ADMIN',
    featureFlagName: 'parametrosAnaliseExtensaoAutomaticaEnabled',
  },
];
